import React from "react";
import Cityvar from "../components/Cityver";
import Homefooter from "../components/Homefooter";
import Unav from "../components/Unav";

function Cityverify() {
    return (
        <>
            <Unav />
            <Cityvar />
            <Homefooter />
        </>
    );
}

export default Cityverify;